import { FormFieldType } from "features/shared/forms/dynamicForm/fields/FormFieldType";
import { DescriptorType } from "../enums/descriptorType";

const FormFieldTypeToDescriptorTypeMap: Partial<Record<FormFieldType, DescriptorType>> = {
  TextBox: DescriptorType.String,
  TextArea: DescriptorType.StringLong,
  SelectBox: DescriptorType.String,
  Select: DescriptorType.String,
  SelectMultiple: DescriptorType.String,
  ContractSelect: DescriptorType.String,
  ContractualAccountSelect: DescriptorType.String,
  InvoiceSelect: DescriptorType.String,
  DatePicker: DescriptorType.Date,
  RadioBoxBool: DescriptorType.Bool,
};

export function getDescriptorDataTypeForFormFieldType(type: FormFieldType): DescriptorType | undefined {
  return FormFieldTypeToDescriptorTypeMap[type];
}
